import * as React from 'react';
import { NavLinkJsx } from '../nav-link-jsx';
import { Logger } from '@wix/bi-logger-wix-answers';

export const TicketNavLink = ({ model, biLogger }: { model: any; biLogger: Logger }) => (
  props,
) => {
  const uri = `/ticket/${props.id}`;

  const onTicketClick = () => {
    return biLogger.publicCustomerPortalViewerClientEngagement({
      data: JSON.stringify({
        id: props.id,
        is_ticket_owner: props.isUserReporter,
        is_ticket_cc: props.isUserCC,
      }),
      engaged_component: 'support_request_list',
      engagement_name: 'click_on_link_to_ticket_page',
      answers_brand_id: model.tenant.brandId,
    });
  };

  return (
    <NavLinkJsx className={props.className} uri={uri} onClick={onTicketClick}>
      {props.children}
    </NavLinkJsx>
  );
};
